<template>
    <transition name="popup-fade">
      <div v-if="isVisible" class="popup-overlay" @click.self="closePopup">
        <div class="popup-content">
          <div class="popup-icon">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <button class="popup-close" @click="closePopup">
            <i class="fas fa-times"></i>
          </button>
          <div class="popup-message">
            <h4>Ошибка</h4>
            <p>{{ message }}</p>
          </div>
          <div class="popup-actions">
            <button @click="closePopup" class="btn btn-popup-close">Понятно</button>
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    props: {
      isVisible: {
        type: Boolean,
        required: true
      },
      message: {
        type: String,
        default: 'Что-то пошло не так.'
      }
    },
    methods: {
      closePopup() {
        this.$emit('close'); // Вызываем событие закрытия pop-up
      }
    }
  };
  </script>
  
  <style scoped>
  .popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10050;
    backdrop-filter: blur(8px);
    animation: fadeIn 0.3s ease;
  }
  
  .popup-content {
    background: white;
    padding: 2rem;
    border-radius: 20px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    position: relative;
    width: 450px;
    max-width: 90%;
    max-height: min(85vh, 520px);
    display: flex;
    flex-direction: column;
    text-align: center;
    animation: slideUp 0.3s ease;
  }
  
  .popup-icon {
    width: 70px;
    height: 70px;
    margin: 0 auto 1.5rem;
    background: linear-gradient(135deg, #f5576c 0%, #f093fb 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    color: white;
    box-shadow: 0 4px 15px rgba(245, 87, 108, 0.4);
  }
  
  .popup-close {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: var(--tcp-color-surface-hover);
    border: none;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    cursor: pointer;
    color: var(--tcp-color-text-slate);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
  }
  
  .popup-close:hover {
    background: var(--tcp-color-border-subtle);
    color: var(--tcp-color-text-body);
    transform: rotate(90deg);
  }
  
  .popup-message {
    margin-bottom: 1.5rem;
    overflow-y: auto;
    flex: 1 1 auto;
    min-height: 0;
  }
  
  .popup-message h4 {
    margin-bottom: 1rem;
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--tcp-color-text-heading);
  }
  
  .popup-message p {
    font-size: 1rem;
    color: var(--tcp-color-text-slate);
    line-height: 1.6;
    word-break: break-word;
    white-space: pre-wrap;
    text-align: left;
  }
  
  .popup-actions {
    margin-top: 1.5rem;
  }
  
  .btn-popup-close {
    background: var(--tcp-gradient-brand);
    border: none;
    color: white;
    padding: 0.75rem 2rem;
    border-radius: 25px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .btn-popup-close:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  }
  
  /* Transitions */
  .popup-fade-enter-active,
  .popup-fade-leave-active {
    transition: opacity 0.3s ease;
  }
  
  .popup-fade-enter-from,
  .popup-fade-leave-to {
    opacity: 0;
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
  </style>
  